(function($){

	/* 
	HTML MARKUP NEEDED / CSS NEEDED
	-div to stick (.stickyItem)
	-div anchor fix (.stickyAnchor)
	-css to stick with fixed position (.sticky class)
	*/

	var stickyItem = $('.stickyItem');
	var stickyItemHeight;

	function stickygetHeight() {
		stickyItemHeight = stickyItem.outerHeight();
	}

	//FUNCTION STICK TO TOP
	function stickyTop() {
	    var window_top = $(window).scrollTop();
	    var div_top = 0;
	    if ($('.stickyAnchor').length){
		    div_top = $('.stickyAnchor').offset().top;
		}
	    if (window_top > div_top + stickyItemHeight) {

	    	//facultatif slidedown animation effect
	    	if(!stickyItem.hasClass('sticky')){
	    		stickyItem.css("top","-"+stickyItemHeight+"px");
		        stickyItem.animate({
			    	top:0
			    }, 300, 'swing');
	    	}
	        
		    stickyItem.addClass('sticky');
	        $('.stickyAnchor').height(stickyItemHeight);
	    } 

	    if (window_top <= div_top) {

	        stickyItem.removeClass('sticky');
	        $('.stickyAnchor').height(0);
	    }
	}

	
	//ON LOAD
	stickygetHeight();
    stickyTop();
	//ON SCROLL
    $(window).scroll(stickyTop);
    //ON RESIZE
    $(window).resize(stickygetHeight);
	
})(jQuery)

